import * as React from "react";
import { Modal as ArchiveModal } from "../modals/Modal";

// helpers imports
import { getHeaders } from "../utils/HeaderHelper";
import { AuthenticationContext } from "../Context";
import { useFlash } from "../FlashContext";


interface Props {
  modalOpen: boolean;
  setModalOpen: any;
  selectedCatId: string;
  setRenderingKey: any;
}

const ArchiveCategory: React.FC<Props> = (props: Props) => {
  // authenticationContext and chat context and other contexts
  const authenticationSetting = React.useContext(AuthenticationContext);

  const { showToast } = useFlash();

  const ArchiveCategory = () => {
    if (props.selectedCatId) {
      fetch(`/action_categories/${props.selectedCatId}/archive`, {
        method: "Put",
        headers: getHeaders(authenticationSetting.csrfToken),
      })
        .then((result) => result.json())
        .then((result) => {
          if (result.success == false) {
            showToast({
              title: "Error",
              text: result.error,
              type: "error",
            });
          } else {
            showToast({
              title: "Category Archived",
              text: "Category has been archived successfully",
              type: "success",
            });
          }
          closeModal();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      showToast({
        title: "Failed to Archive",
        text: "Failed to archive category",
        type: "error",
      });
      closeModal();
    }
  };

  const closeModal = () => {
    props.setRenderingKey(Math.random);
    props.setModalOpen(false);
  };

  return (
    <>
      <ArchiveModal
        successModalOpen={props.modalOpen}
        setSuccessModalOpen={props.setModalOpen}
        successHeader={"Archive Custom Category"}
        successContent={
          "You are attempting to archive this category. This cannot be undone. This will not affect published actions. Would you like to continue?"
        }
        successCallback={ArchiveCategory}
        closeCallback={closeModal}
        confirmButtonText="Archive Category"
      />
    </>
  );
};

export default ArchiveCategory;
